<template>
	<div class="a-switch" :class="{ 'a-switch--dark' : onDark }">
		<input autocomplete="off" type="radio" class="a-switch__input" name="view" value="" :id="id[0]" checked>
        <label :for="id[0]" class="a-switch__label a-switch__label--off" :class="{ 'a-switch__label--dark' : onDark }">{{labels[0]}}</label>
        <input autocomplete="off" type="radio" class="a-switch__input" name="view" value="" :id="id[1]">
        <label :for="id[1]" class="a-switch__label a-switch__label--on" :class="{ 'a-switch__label--dark' : onDark }">{{labels[1]}}</label>
        <span class="a-switch__selection"></span>
	</div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'switch-button',
        props: {
            labels: {
                type: Array,
            },
            id: {
            	type: Array,
            },
            onDark: {
                type: Boolean,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SwitchButton.vue?21c3f820